import React from 'react';
import {
  Box,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField
} from '@mui/material';
import DatePickerComponent from '../ui/datePickerComponent';
import { SelectLocation } from '../common';
import CustomerSearch from '../customerSearch/customerSearch';

const ReportFilters = ({ selectedReport, filters, setFilters }) => {
  if (!selectedReport) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" gutterBottom>Report Filters</Typography>
      <Grid container spacing={2}>
        {selectedReport === 'daily-sales' && (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <DatePickerComponent
                name="date"
                id="report-date"
                value={filters.date}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, date: date || prev.date }))}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <SelectLocation
                location={filters.locationId}
                setLocation={(location) => setFilters(prev => ({ 
                  ...prev, 
                  locationId: location ? location.id : '' 
                }))}
                fullWidth
                required
                helperText="Required - Select location for report"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size='small'>
                <InputLabel>Items per page</InputLabel>
                <Select
                  value={filters.limit}
                  onChange={(e) => setFilters(prev => ({ ...prev, limit: parseInt(e.target.value), page: 1 }))}
                >
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={200}>200</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </>
        )}
        
        {selectedReport === 'monthly-sales' && (
          <>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Year"
                type="number"
                value={filters.year}
                onChange={(e) => setFilters(prev => ({ ...prev, year: parseInt(e.target.value) }))}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Month"
                type="number"
                inputProps={{ min: 1, max: 12 }}
                value={filters.month}
                onChange={(e) => setFilters(prev => ({ ...prev, month: parseInt(e.target.value) }))}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <SelectLocation
                location={filters.locationId}
                setLocation={(location) => setFilters(prev => ({ 
                  ...prev, 
                  locationId: location ? location.id : '' 
                }))}
                fullWidth
                helperText="Optional - Select location to filter by"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth size='small'>
                <InputLabel>Items per page</InputLabel>
                <Select
                  value={filters.limit}
                  onChange={(e) => setFilters(prev => ({ ...prev, limit: parseInt(e.target.value), page: 1 }))}
                >
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                  <MenuItem value={200}>200</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </>
        )}

        {selectedReport === 'inventory' && (
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Product Type</InputLabel>
              <Select
                value={filters.type}
                onChange={(e) => setFilters(prev => ({ ...prev, type: e.target.value }))}
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="frames">Frames</MenuItem>
                <MenuItem value="lenses">Lenses</MenuItem>
                <MenuItem value="contacts">Contacts</MenuItem>
                <MenuItem value="accessories">Accessories</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}

        {selectedReport === 'customers' && (
          <>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Period</InputLabel>
                <Select
                  value={filters.period}
                  onChange={(e) => setFilters(prev => ({ ...prev, period: e.target.value }))}
                >
                  <MenuItem value="daily">Daily</MenuItem>
                  <MenuItem value="weekly">Weekly</MenuItem>
                  <MenuItem value="monthly">Monthly</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                name="date"
                id="customer-report-date"
                value={filters.date}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, date: date || prev.date }))}
              />
            </Grid>
          </>
        )}

        {selectedReport === 'payment-methods' && (
          <>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                name="startDate"
                id="payment-start-date"
                value={filters.startDate}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, startDate: date || prev.startDate }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                name="endDate"
                id="payment-end-date"
                value={filters.endDate}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, endDate: date || prev.endDate }))}
              />
            </Grid>
          </>
        )}

        {selectedReport === 'individual-customer' && (
          <>
            <Grid item xs={12}>
              <CustomerSearch
                onCustomerSelected={(customer) => setFilters(prev => ({ 
                  ...prev, 
                  customerId: customer ? customer.id : null 
                }))}
                disableAdd={true}
                sx={{ width: '50%' }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                name="startDate"
                id="individual-customer-start-date"
                value={filters.startDate}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, startDate: date || prev.startDate }))}
                helperText="Optional - Filter from this date"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <DatePickerComponent
                name="endDate"
                id="individual-customer-end-date"
                value={filters.endDate}
                onDateSelectionDone={(date) => setFilters(prev => ({ ...prev, endDate: date || prev.endDate }))}
                helperText="Optional - Filter to this date"
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ReportFilters;
